/**
 * Pet Mindful · Revelado al entrar en pantalla
 *
 * Marca con .is-in los elementos [data-pm-reveal] cuando entran en el
 * viewport, para que una animación arranque al verla y no antes: los bloques
 * de la ficha quedan muy abajo y, animados al cargar, la animación termina
 * sin que nadie la vea.
 *
 * Las animaciones son aditivas: sin JS, o si el observer falla, el elemento
 * ya está en su estado final. Nada depende de que este archivo corra.
 */
(() => {
  const SELECTOR = '[data-pm-reveal]';
  const VISIBLE = 'is-in';

  const reveal = (el) => el.classList.add(VISIBLE);

  const init = (root = document) => {
    const targets = root.querySelectorAll(`${SELECTOR}:not(.${VISIBLE})`);
    if (!targets.length) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach(reveal);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.2 }
    );

    targets.forEach((el) => observer.observe(el));
  };

  init();

  // El editor de temas vuelve a pintar la sección sin recargar la página
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
